var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.isLoggedIn)?_c('div',{staticClass:"cp-backoffice-view"},[_c('Navigation'),_c('div',{staticClass:"cp-backoffice-view-container"},[_c('Sidebar'),_c('router-view',{attrs:{"name":"backoffice-view"}})],1)],1):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }